import {useTranslation} from "react-i18next";
import DateDisplay from "components/datetime/DateDisplay";

import IconBool from "components/IconBool";
import Queue from "components/queues/Queue";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableUpdates = ({items, itemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Tt} = useTranslation("tags");

    const stickyHeaderStyle = {
        position: "sticky",
        top: "194px",
        backgroundColor: "white",
        zIndex: 899,
    };

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(e.currentTarget.dataset.idx);
        } else {
            items.current.removeFromChosen(e.currentTarget.dataset.idx);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.uuid);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.send.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th
                        style={{
                            width: "32px",
                            verticalAlign: "bottom",
                            ...stickyHeaderStyle,
                        }}>
                        <input
                            className="form-check-input sticky-top border-bottom-sticky"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tt("common.shipping")}
                        <br />
                        <span className="small">{_Tt("common.date")}</span>
                        <br />
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tt("common.confirmed")}
                        <br />
                        <span className="small">{_Tt("common.date")}</span>
                        <br />
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tt("common.expires")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tt("common.updated")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tt("common.status")}
                    </th>
                    <th
                        style={{
                            width: "50px",
                            textAlign: "center",
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky">
                        {_Tt("common.queue")}
                    </th>
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.map((item) => (
                    <tr key={item.uuid} data-idx={item.uuid} onChange={onClick}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.uuid}
                                data-idx={item.uuid}
                                defaultChecked={items.current.chosen.includes(item.uuid)}
                                readOnly={true}
                            />
                        </td>
                        <td>
                            {item.uuid}
                            <br />
                            {item.model_name}
                        </td>
                        <td>{item.version}</td>
                        <td>{item.installed}</td>
                        <td>
                            <span title="Enviado" className="me-2">
                                E {<IconBool value={item.sent} />}
                            </span>
                            <br />
                            {item.sent_at ? <DateDisplay date={item.sent_at} format="DD-MM-YYYY HH:mm" title={true} /> : "-"}
                        </td>
                        <td>
                            <span title="Enviado" className="me-2">
                                E {<IconBool value={item.ack} />}
                            </span>
                            <br />
                            {item.ack_at ? <DateDisplay date={item.ack_at} format="DD-MM-YYYY HH:mm" title={true} /> : "-"}
                        </td>
                        <td>
                            {item.expired_at ? (
                                <DateDisplay date={item.expired_at} format="DD-MM-YYYY HH:mm" title={true} />
                            ) : (
                                <></>
                            )}
                        </td>
                        <td>
                            {item.updated_at ? (
                                <DateDisplay date={item.updated_at} format="DD-MM-YYYY HH:mm" title={true} />
                            ) : (
                                <></>
                            )}
                        </td>
                        <td>{_Tc("firmwareState." + item.state)}</td>
                        <td className="text-center">
                            <Queue item={item.queue} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableUpdates;
